import React from 'react';

import StudyCounters from '../../StudyList/StudyCounters';

function StudySubmittedQuestions({
  history,
  counterSubmitted,
  otherUsersQuestions = false,
}) {
  const classes =
    'd-flex list-group-item flex-row align-items-center justify-content-between cursor-pointer';
  return (
    <ul className="ulStyle">
      <li
        className={classes}
        data-test="study-my-submitted-questions-button"
        onClick={() => {
          if (otherUsersQuestions) {
            history('/app/question/studySubmittedQuestions');
          } else {
            history('/app/question/studyMySubmittedQuestion');
          }
        }}
      >
        <div className="titleAndNeedPub">
          <div className="d-flex flex-row align-items-center list-title ">
            <span className="d-flex ml-2 mr-2">
              {otherUsersQuestions
                ? 'STUDY ALL SUBMITTED QUESTIONS IN MY AFSC'
                : 'STUDY MY SUBMITTED QUESTIONS'}
            </span>
          </div>
        </div>
        <StudyCounters
          id={16239}
          reviewWhen={null}
          new={counterSubmitted?.new ?? 0}
          learning={counterSubmitted?.learning ?? 0}
          review={counterSubmitted?.review ?? 0}
        />
      </li>
    </ul>
  );
}

export default StudySubmittedQuestions;
